const TITLE_WORDS = new Set(["dr", "dr.", "mr", "mr.", "mrs", "mrs.", "ms", "ms.", "miss", "prof", "prof."]);
export const getInitials = (name) => {
    const words = name.split(/\s+/).filter(Boolean);
    const nameWords = words.filter(word => !TITLE_WORDS.has(word.toLowerCase()));
    const initialsSource = nameWords.length ? nameWords : words;
    // Take the first and last word so multi-word surnames (eg. "van den Bergen") only contribute one initial.
    const firstLast = initialsSource.length > 1 ? [initialsSource[0], initialsSource[initialsSource.length - 1]] : initialsSource;
    return firstLast.map(word => { var _a; return (_a = word[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase(); }).join("");
};
